// extracted by mini-css-extract-plugin
module.exports = {"nav":"editUserPage_nav__1eoiB"};